import React from 'react'
import Breadcrub from '../Common/Breadcrub'

const Laboratories = () => {
  return (
    <>
     <Breadcrub title="Laboratories"  />
        <section class="aboutus-style-01">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-12">
                        <div class="row g-0">                           
                            <div class="col-md-12">
                                <div class="p-1-0 p-sm-1-9">
                                    <p>Mahatma Gandhi Institute of Medical Sciences is contained spacious & well stocked laboratories to perform various experiments in the sciences of Pharmacy.</p>
                                    <ul>
                                        <li>
                                            <p className='fw-bold mb-0'>Pharmaceutics Lab</p>
                                            <p>Pharmaceutics deals with the formulation of pure drug substance into a dosage form. Branches of pharmaceutics include the study of relationship between drug formulation, delivery, disposition and clinical response. </p>
                                        </li>
                                        <li>
                                            <p className='fw-bold mb-0'>Model Pharmacy</p>
                                            <p>Pharmaceutical Care Models is a patient-centered, outcomes oriented pharmacy practice that requires the pharmacist to work in concert with the patient and the patient's other healthcare providers to promote health, to prevent disease, and to assess, monitor, initiate, and modify the use of medication. </p>
                                        </li>
                                        <li>
                                            <p className='fw-bold mb-0'>Human Anatomy and Pathology lab</p>
                                            <p>Anatomy is the science of understanding the structure and the parts of living organisms. Physiology, on the other hand, deals with the internal mechanisms and the processes that work towards sustaining life. </p>
                                        </li>
                                        <li>
                                            <p className='fw-bold mb-0'>Pharmaceutical Chemistry Lab</p>
                                            <p>The Pharmaceutical Chemistry lab is the backbone of the institute. It deals with study of compounds’ structure, synthesis, identification and characterization.</p>
                                        </li>
                                        <li>
                                            <p className='fw-bold mb-0'>Pharmacology Lab</p>
                                            <p>The department is involved in screening of natural and synthetic drugs for their pharmacological activities using in vitro and in vivo models involving preclinical and toxicological studies. </p>
                                        </li>
                                        <li>
                                            <p className='fw-bold mb-0'>Pharmacognosy Lab</p>
                                            <p>This lab is meant for extraction, isolation, purification, and identification of active chemical constituents from medicinal plants. </p>
                                        </li>
                                        <li>
                                            <p className='fw-bold mb-0'>Pharmacy Practice Lab</p>
                                            <p>Students in the Doctor of Pharmacy curriculum utilize the laboratory on multiple occasions throughout their professional curriculum. In addition to being the site of training in basic compounding, the laboratory also serves as a staging area for more advanced laboratory courses within the curriculum. </p>
                                        </li>
                                    </ul>                       
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Laboratories
